import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';

import { CacheService } from '@app/services/cache.service';
import { selectSelectedPortfolioId } from '@dashboards/store/selectors/property-selector.selectors';
import {
  loadCalendarInspections,
  loadCalendarInspectionsFailed,
  loadCalendarInspectionsSuccess,
} from '@main-application/calendar/store/calendar.actions';
import { InspectionsType } from '@main-application/inspections/components/inspections-list/inspections-list.component';
import { InspectionService } from '@main-application/inspections/services/inspection.service';

@Injectable()
export class CalendarEffects {
  loadCalendarInspections$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCalendarInspections),
      withLatestFrom(this.store.select(selectSelectedPortfolioId)),
      mergeMap(([action, portfolioId]) =>
        this.cacheService
          .getCachedInfo(
            `calendarInspections-${portfolioId}-${moment(action.startDate).format('yyyy-MM-DD')}-${moment(
              action.endDate
            ).format('yyyy-MM-DD')}`,
            0,
            () => this.inspectionService.list(portfolioId, action.startDate, action.endDate, InspectionsType.User, true)
          )
          .pipe(
            map(inspections => loadCalendarInspectionsSuccess({ inspections })),
            catchError(err => {
              return of(loadCalendarInspectionsFailed());
            })
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<{}>,
    private inspectionService: InspectionService,
    private cacheService: CacheService
  ) {}
}
